import { create } from 'zustand';

interface IMainState {
  visibleKey: string;
  openModal: (key: string) => void;
  closeModal: () => void;
}

export const useMainStore = create<IMainState>((set) => ({
  visibleKey: '',
  openModal: (modalKey: string) => set(() => ({ visibleKey: modalKey })),
  closeModal: () => set(() => ({ visibleKey: '' })),
}));
